import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText';

export const validationFields = {
  name: yup.string().required(REQUIRED),
  phoneNumber: yup.string().required(REQUIRED),
  email: yup.string().nullable(),
  customerServiceEmail: yup.string().nullable(),
  normalOpeningHour: yup.number().nullable(),
  normalClosingHour: yup.number().nullable(),
  sundayOpeningHour: yup.number().nullable(),
  sundayClosingHour: yup.number().nullable(),
  brandBackgroundUmageUrl: yup.string(),
  brandLogoImageUrl: yup.string(),
  brandLocationMapUrl: yup.string(),
  categoryIds: yup.array(),
  isFeatured: yup.boolean(),
  storeNumber: yup.string(),
  uniqueInState: yup.boolean().required(REQUIRED),
  fastCashEnabled: yup.boolean().required(REQUIRED),
  billingAddress: yup.string(),
  defaultCashbackRate: yup.number().required(REQUIRED),
  birthdayCashbackRate: yup.number().nullable(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = () => {
  const initialValues = {
    name: '',
    phoneNumber: '',
    storeNumber: '',
    uniqueInState: false,
    fastCashEnabled: false,
    defaultCashbackRate: 15,
    birthdayCashbackRate: null,
    email: '',
    isFeatured: false,
    customerServiceEmail: '',
    billingAddress: '',
    normalOpeningHour: null,
    normalClosingHour: null,
    sundayOpeningHour: null,
    sundayClosingHour: null,
    logoImage: null,
    backgroundImage: null,
    locationMap: null,
    categoryIds: [],
  };

  return initialValues;
};
